<script lang="ts" setup>
import { inject } from 'vue';

import type { Ref } from 'vue';

const envMapFile = inject('envMapFile') as Ref<string>;
const availableEnvMaps = new Set<string>(__ENVIRONMENT_MAPS__);
</script>

<template>
  <div class="flex flex-row mb-1 items-center">
    <label for="envmap-file" class="text-xs mr-2">File</label>

    <select v-model="envMapFile" class="text-xs flex-grow border bg-white p-1">
      <option v-for="availableEnvMap in availableEnvMaps" :key="availableEnvMap" :value="availableEnvMap">
        {{ availableEnvMap }}
      </option>
    </select>
  </div>
</template>
